module.exports = __webpack_public_path__ + "img/pedidos.48ec355a.svg";